<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">
      <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 class="mt-2 text-3xl text-gray-900">Rastrear Envio</h1>
          <p class="mt-2 max-w-2xl text-sm text-gray-500">Consulte envios realizados pelo telefone do contato ou COD CLIENTE.</p>
        </div>
      </div>

      <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div class="p-6">
          <div class="grid grid-cols-1 gap-4 md:grid-cols-4">
            <div class="flex flex-col gap-1 md:col-span-2">
              <label class="text-sm font-medium text-gray-500"> Telefone Contato </label>
              <input
                v-model="telefone"
                type="text"
                placeholder="Buscar contato ou COD CLIENTE..."
                class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                @keyup.enter="start"
              />
            </div>

            <div class="flex items-end gap-2 md:col-span-2 lg:col-span-1">
              <button type="button" class="h-11 w-full rounded-xl bg-blue-500 font-medium text-white transition hover:bg-blue-600" @click="start">Buscar</button>

              <button type="button" class="h-11 rounded-xl border border-gray-200 bg-white px-4 font-medium text-gray-700 transition hover:bg-gray-50" @click="limparBusca">Limpar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="w-full overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div class="overflow-x-auto">
          <table class="w-full min-w-max text-sm">
            <thead class="border-b bg-gray-100 tracking-wider text-gray-600">
              <tr>
                <th class="px-6 py-4 text-left font-medium">Número</th>
                <th class="px-6 py-4 text-left font-medium">Campanha</th>
                <th class="px-6 py-4 text-left font-medium">ID Custom</th>
                <th class="px-6 py-4 text-left font-medium">Centro de Custo</th>
                <th class="px-6 py-4 text-left font-medium">Mensagem</th>
                <th class="px-6 py-4 text-center font-medium">Tipo</th>
                <th class="px-6 py-4 text-center font-medium">{{ $store.getters.rotuloEnvio('Enviou', 'Enviou para a fila') }}</th>
                <th v-if="exibirStatusRastreamento" class="px-6 py-4 text-center font-medium">Status</th>
                <th class="px-6 py-4 text-center font-medium">Validação WhatsApp</th>
                <th class="px-6 py-4 text-left font-medium">Data</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, index) in listPaginada" :key="getRowKey(item, index)" class="border-b border-gray-100 transition hover:bg-slate-50">
                <td class="px-6 py-5">
                  <div class="flex items-center gap-4">
                    <div class="flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-50 text-sm font-semibold text-blue-700">
                      {{ (item.telefone || "--").slice(-2) }}
                    </div>

                    <div class="flex flex-col">
                      <span class="font-medium text-gray-800">
                        {{ item.telefone || "-" }}
                      </span>
                      <span class="text-xs text-gray-400"> Contato rastreado </span>
                    </div>
                  </div>
                </td>

                <td class="px-6 font-medium text-gray-700">
                  {{ item.campanha || "-" }}
                </td>

                <td class="px-6 font-medium text-gray-700">
                  {{ item.idCustom || "-" }}
                </td>

                <td class="px-6 font-medium text-gray-700">
                  {{ item.centrocusto || "-" }}
                </td>

                <td class="max-w-sm px-6 py-5 text-gray-600" :title="item.mensagem">
                  <div class="flex flex-col gap-2">
                    <div class="flex items-start justify-between gap-2">
                      <span>
                        {{ item.mensagem && item.mensagem.length > 40 ? `${item.mensagem.slice(0, 40)}...` : item.mensagem || "-" }}
                      </span>

                      <button
                        type="button"
                        class="flex items-center gap-1 rounded-lg border border-gray-200 bg-white px-2 py-1 text-xs text-gray-600 shadow-sm transition hover:-translate-y-0.5 hover:bg-gray-50 hover:shadow-md"
                        @click="copy(item.mensagem, getRowKey(item, index))"
                      >
                        <svg v-if="copiedRowKey !== getRowKey(item, index)" class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16h8M8 12h8m-9 8h10a2 2 0 002-2V6a2 2 0 00-2-2H7a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>

                        <svg v-else class="h-4 w-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>

                        {{ copiedRowKey === getRowKey(item, index) ? "Copiado!" : "Copiar" }}
                      </button>
                    </div>

                    <a
                      v-if="item.arquivo && item.arquivo.filename"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="inline-flex items-center justify-center h-8 w-8 rounded-lg border border-blue-200 bg-blue-50 text-blue-600 shadow-sm transition hover:bg-blue-100 hover:border-blue-300"
                      :href="`${api}/upload?mimetype=${encodeURIComponent(item.arquivo.mimetype || 'application/octet-stream')}&filename=${encodeURIComponent(item.arquivo.filename)}&folder=arquivosWhats`"
                      :title="`Baixar: ${item.arquivo.filename}`"
                    >
                      <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8m0 8l-4-2m4 2l4-2" />
                      </svg>
                    </a>
                  </div>
                </td>

                <td class="px-6 text-center">
                  <span class="rounded-full bg-slate-100 px-3 py-1 text-xs font-medium text-gray-700">
                    {{ !item.validacao ? "Envio" : "Validação" }}
                  </span>
                </td>

                <td class="px-6 text-center">
                  <span class="rounded-full px-3 py-1 text-xs font-medium" :class="item.enviou ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'">
                    {{ item.enviou ? "SIM" : "NÃO" }}
                  </span>
                </td>

                <td v-if="exibirStatusRastreamento" class="px-6 text-center">
                  <span class="rounded-full px-3 py-1 text-xs font-medium" :class="statusRastreamentoClass(item)">
                    {{ item.statusRastreamento || "PENDENTE" }}
                  </span>
                </td>

                <td class="px-6 text-center">
                  <span class="rounded-full px-3 py-1 text-xs font-medium" :class="validacaoWhatsappClass(item)">
                    {{ validacaoWhatsappLabel(item) }}
                  </span>
                </td>

                <td class="px-6 font-medium text-gray-700">
                  <span v-if="item.data">
                    {{ item.data | moment("DD/MM/YYYY HH:mm") }}
                  </span>
                  <span v-else>-</span>
                </td>
              </tr>

              <tr v-if="list.length === 0">
                <td :colspan="colspanTabela" class="px-6 py-12 text-center text-sm text-gray-400">Nenhum envio encontrado. Faça uma busca para visualizar os registros.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <AppPagination
        v-if="list.length > 0"
        :current-page="paginaAtual"
        :total-pages="totalPaginas"
        :total-items="list.length"
        :page-size="itensPorPagina"
        item-label="registros"
        @paginate="setPage"
      />
    </div>
  </div>
</template>

<script>
import AppPagination from "@/components/AppPagination.vue";

export default {
  components: {
    AppPagination
  },
  data() {
    return {
      telefone: "",
      list: [],
      paginaAtual: 1,
      itensPorPagina: 10,
      total: 0,
      exibirStatusRastreamento: false,
      copiedRowKey: null,
      api: window.location.hostname === "uno.trestto.com.br" ? "https://uno.trestto.com.br/api" : process.env.VUE_APP_API
    };
  },

  computed: {
    listPaginada() {
      const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
      return this.list.slice(inicio, inicio + this.itensPorPagina);
    },

    totalPaginas() {
      return Math.max(1, Math.ceil(this.list.length / this.itensPorPagina));
    },

    colspanTabela() {
      return this.exibirStatusRastreamento ? 10 : 9;
    }
  },

  methods: {
    getRowKey(item, index) {
      return `${index}-${item._id || ""}-${item.telefone || ""}-${item.data || ""}`;
    },

    statusRastreamentoClass(item) {
      if ([3, 4].includes(item.codigoStatusRastreamento)) return "bg-green-100 text-green-700";
      if ([0, 9].includes(item.codigoStatusRastreamento)) return "bg-red-100 text-red-700";
      if (item.codigoStatusRastreamento === 1) return "bg-blue-100 text-blue-700";
      return "bg-slate-100 text-slate-600";
    },

    validacaoWhatsappLabel(item) {
      if (item.validacaoWhatsapp) return item.validacaoWhatsapp;
      if (item.temzapValidado === true) return "SIM";
      if (item.temzapValidado === false) return "NÃO";
      return "NÃO VALIDADO";
    },

    validacaoWhatsappClass(item) {
      if (item.temzapValidado === true) return "bg-green-100 text-green-700";
      if (item.temzapValidado === false) return "bg-red-100 text-red-700";
      return "bg-slate-100 text-slate-600";
    },

    async start() {
      if (!this.telefone) return this.$vToastify.error("Telefone é obrigatório");

      let centrocusto;
      if (this.$store.state.user.centrocusto && !this.$store.state.user.admin) {
        centrocusto = this.$store.state.user.centrocusto;
      }

      const dataReq = await this.$http.post("/v1/campanhasLZV2/consulta-numero-api", {
        numero: this.telefone,
        centrocusto,
        registrarRTPotencial: true
      });

      this.exibirStatusRastreamento = dataReq.data.exibirStatusRastreamento === true;
      this.list = dataReq.data.data || [];
      this.total = dataReq.data.total || this.list.length;
      this.paginaAtual = 1;
      this.copiedRowKey = null;
    },

    limparBusca() {
      this.telefone = "";
      this.exibirStatusRastreamento = false;
      this.list = [];
      this.paginaAtual = 1;
      this.total = 0;
      this.copiedRowKey = null;
    },

    setPage(page) {
      this.paginaAtual = page;
    },

    copy(text, rowKey) {
      if (!text) return;

      navigator.clipboard.writeText(text);
      this.copiedRowKey = rowKey;
      this.$vToastify.success("Mensagem copiada!");

      setTimeout(() => {
        if (this.copiedRowKey === rowKey) {
          this.copiedRowKey = null;
        }
      }, 2000);
    }
  }
};
</script>
